import I18n from 'I18n';
import { getPropertyDisplayName } from 'ui-deal-management-components-lib/utils/dealPropertyUtils';

// Used when displaying unformatted string
export const getForecastTypeDescription = ({
  forecastType,
  properties
}) => `${I18n.text('forecastType.basedOn')} ${getPropertyDisplayName(properties, forecastType === null || forecastType === void 0 ? void 0 : forecastType.dateProperty)} ${I18n.text('forecastType.and')} ${getPropertyDisplayName(properties, forecastType === null || forecastType === void 0 ? void 0 : forecastType.amountProperty)}`;